import React, { useState, useEffect } from 'react';

import { useSelector } from 'react-redux';
import { FaTrash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './cart.css';

const Cart = () => {
  const [cartItems, setCartItems] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const productState = useSelector((state) => state.products);
  const { loading, error, products } = productState;
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('userDetails'));
    if (!user) {
      setIsLoggedIn(false);
    } else {
      setIsLoggedIn(true);
      getCartItems(user._id);
    }
  }, []);

  const getCartItems = async (userId) => {
    try {
      const response = await fetch(`https://swarna-herbal-backend.onrender.com/api/cart/getCartItems?userId=${userId}`);
      const data = await response.json();
      if (response.ok) {
        const itemsWithDetails = data.items.map((cartItem) => {
          const fullItem = products.find((item) => item._id == cartItem.itemId);
          return {
            ...cartItem,
            ...fullItem,
          };
        });
        setCartItems(itemsWithDetails);
      } else {
        console.error('Failed to fetch cart products');
      }
    } catch (err) {
      console.error('Error fetching cart:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const updateQuantity = (itemId, increment) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.itemId === itemId
          ? { ...item, quantity: Math.max(1, item.quantity + increment) }
          : item
      )
    );
  };

  const handleRemoveItem = async (itemId) => {
    const user = JSON.parse(localStorage.getItem('userDetails'));
    if (!user) {
      navigate('/login');
      return;
    }

    try {
      const response = await fetch('https://swarna-herbal-backend.onrender.com/api/cart/removeItem', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId: user._id, itemId }),
      });

      if (response.ok) {
        setCartItems((prevItems) => prevItems.filter((item) => item.itemId !== itemId));
      } else {
        console.error('Failed to remove item');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const calculateTotalPrice = (products) => {
    const total = products.reduce(
      (acc, item) => acc + item.offerPrice * item.quantity,
      0
    );
    setTotalPrice(total);
  };

  useEffect(() => {
    calculateTotalPrice(cartItems);
  }, [cartItems]);

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate('/login');
  };

  const handleCheckout = () => {
    if (totalPrice > 0) {
      navigate('/order-cart-item', {
        state: { cartItems, totalPrice },
      });
    }
  };

  return (
    <div className="cart-container">
      {!isLoggedIn ? (
        <div className="search-container">
          <h2>Login To Check Cart Details</h2>
          <form onSubmit={handleSubmit} className="search-form">
            <button type="submit" className="search-button">Login</button>
          </form>
        </div>
      ) : (
        <>
          <h1 className="cart-title">Your Cart</h1>
          {isLoading ? (
            <p>Loading cart...</p>
          ) : cartItems.length === 0 ? (
            <p>Your cart is empty.</p>
          ) : (
            <div className="cart-items">
              {cartItems.map((item) => (
                <div key={item.itemId} className="cart-item">
                  <img
                    src={`https://swarna-herbal-backend.onrender.com/uploads/${item.image}`}
                    alt={item.name}
                    className="product-image"
                  />
                  <div className="product-info">
                    <h3 className="product-name">{item.name}</h3>
                    <p className="product-price">₹{item.offerPrice}</p>
                  </div>
                  <div className="quantity-control">
                    <button onClick={() => updateQuantity(item.itemId, -1)} className="quantity-button">-</button>
                    <input type="number" value={item.quantity} readOnly className="quantity-input" />
                    <button onClick={() => updateQuantity(item.itemId, 1)} className="quantity-button">+</button>
                    <FaTrash className="delete-icon" onClick={() => handleRemoveItem(item.itemId)} />
                  </div>
                </div>
              ))}

              <div className="total-price-section">
                <h3 className="total-price">Total: ₹{totalPrice}</h3>
                {totalPrice < 500 && (
                  <p className="free-delivery-message">Add more products for free delivery!</p>
                )}
                <button
                  className={`checkout-button ${totalPrice === 0 ? 'disabled' : ''}`}
                  disabled={totalPrice === 0}
                  onClick={handleCheckout}
                >
                  Checkout
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Cart;
